import * as ana from './ana'
import * as insurance from './insurance'
import * as signedDocuments from './signedDocuments'

export default { ana, insurance, signedDocuments }
